// tabsConfig.ts
import {
  HomeTab,
  BrokerViewTab,
  ClientHomeTab,
  LoggedOutTab,
  LoggedOutExploreFeedsTab,
  type BreakpointLayouts,
  type DashboardTab,
} from "./DashboardLayouts";

type TabConfig = {
  title: string;
  defaultWidgets: string[];
  layout: BreakpointLayouts;
};

export const getTabsConfig = (
  isInternalNewsquawkUser: boolean
): Record<string, TabConfig> => ({
  default: {
    title: "Home",
    defaultWidgets: isInternalNewsquawkUser
      ? HomeTab.widgets
      : ClientHomeTab.widgets,
    layout: isInternalNewsquawkUser ? HomeTab.layouts : ClientHomeTab.layouts,
  },
  // Conditionally add the BrokerView tab if the user is an internal Newsquawk user
  ...(isInternalNewsquawkUser && {
    BrokerView: {
      title: "Broker View",
      defaultWidgets: BrokerViewTab.widgets,
      layout: BrokerViewTab.layouts,
    },
  }),
});

function mapConfigToTabs(config: Record<string, TabConfig>): DashboardTab[] {
  return Object.entries(config).map(([tabId, entry]) => ({
    id: tabId,
    title: entry.title,
    layout: entry.layout,
    enabledWidgets: entry.defaultWidgets,
  }));
}

export function getDefaultTabs(
  isInternalNewsquawkUser: boolean
): DashboardTab[] {
  return mapConfigToTabs(getTabsConfig(isInternalNewsquawkUser));
}

const loggedOutTabsConfig: Record<string, TabConfig> = {
  default: {
    title: "Login for live data",
    defaultWidgets: LoggedOutTab.widgets,
    layout: LoggedOutTab.layouts,
  },
  exploreFeeds: {
    title: "Explore Feeds",
    defaultWidgets: LoggedOutExploreFeedsTab.widgets,
    layout: LoggedOutExploreFeedsTab.layouts,
  },
};

export function getLoggedOutTabs(): DashboardTab[] {
  return mapConfigToTabs(loggedOutTabsConfig);
}
